
import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { useAuth } from "@/contexts/AuthContext";
import { PresenceProvider } from "@/contexts/PresenceContext";
import { SidebarProvider, useSidebar } from "@/contexts/SidebarContext";
import LoadingScreen from "@/components/LoadingScreen";

interface ChatLayoutProps {
  children: React.ReactNode;
}

const ChatLayoutContent = ({ children }: ChatLayoutProps) => {
  const { loading } = useAuth();
  const { isOpen } = useSidebar();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  
  // Set a short timeout to prevent flash of incorrect auth state
  useEffect(() => {
    if (!loading) {
      // Small delay to ensure auth state is fully propagated
      const timer = setTimeout(() => setIsInitialLoading(false), 100);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (isInitialLoading || loading) {
    return <LoadingScreen message="Loading your session..." />;
  }

  return (
    <PresenceProvider>
      <div 
        className={`h-screen flex flex-col bg-background text-foreground overflow-hidden fixed inset-0 transition-all duration-300 ease-in-out ${isOpen ? 'w-[calc(100vw-80px)]' : 'w-full'}`}
      >
        <Navbar />
        <main className="flex-1 overflow-hidden min-h-0">
          {children}
        </main>
      </div>
    </PresenceProvider>
  );
};

const ChatLayout = ({ children }: ChatLayoutProps) => {
  return (
    <SidebarProvider>
      <ChatLayoutContent>{children}</ChatLayoutContent>
    </SidebarProvider>
  );
};

export default ChatLayout;
